module.exports = __webpack_public_path__ + "img/addIcon.92fa071d.svg";